import * as React from "react";
import styled from "@mui/material/styles/styled";
import { PatientDataInputView } from "../PatientDataInputView";
import { PatientCaseGrouping } from "../../../context/diagnosticAgent";
import { useDataInputPanels } from "../useDataInputPanels";
import { KahunPanelSubGroup } from "shared";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { useHistory, useRouteMatch } from "react-router";
import { removeTrailingSlash } from "fe-common/routes/removeTrailingSlash";

//region [[ Styles ]]

const VitalSignsSectionView = styled("div")(({ theme }) => ({
  [theme.breakpoints.down(MobileView)]: {
    margin: "-7px", // Kill the contentWrapper 7px padding
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface VitalSignsSectionProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const VitalSignsSection = ({ ...props }: VitalSignsSectionProps) => {
  const { panels, loading } = useDataInputPanels();

  const match = useRouteMatch();
  // Clean "/" from path in the end if exists
  const matchPath = removeTrailingSlash(match.path);

  const history = useHistory();

  const onChangeSection = (newSection: PatientCaseGrouping) => {
    history.push(`${matchPath}/${newSection}`);
  };

  return (
    <VitalSignsSectionView>
      <PatientDataInputView
        singlePanel={true}
        panels={panels}
        loading={loading}
        section={PatientCaseGrouping.CLINICAL_FEATURES}
        categoryid={KahunPanelSubGroup.VitalSign}
        sectionTitle={"Vital Signs"}
        onChangeSection={onChangeSection}
      />
    </VitalSignsSectionView>
  );
};
